'use client';

import { Button, NavbarItem } from '@nextui-org/react';
import Link from 'next/link';
import { ROUTES } from '@/shared/routes/routes';
import { Heart } from 'lucide-react';

import { useGetLocalStorageFavoritesCountQuery } from '@/entities/favorite/query';

export const FavoritesLink = () => {
  const { data: cartCount } = useGetLocalStorageFavoritesCountQuery();
  return (
    <NavbarItem className="px-0 hidden md:flex">
      <div className="relative flex items-start">
        <Link href={ROUTES.favorites} aria-label="Избранное">
          <Button
            className="relative"
            isIconOnly
            radius="full"
            variant="light"
            aria-label="Избранное"
            title="Избранное"
          >
            {cartCount > 0 && (
              <span className=" absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary">
                {cartCount}
              </span>
            )}
            <Heart size={24} strokeWidth={1.25} />
          </Button>
        </Link>
      </div>
    </NavbarItem>
  );
};
